import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 12",
  class: "jl2-custom-simple-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.05 8.86H3.02L1.89 12H.26L4.84 0h1.38l4.59 12H9.19L8.04 8.86h.01ZM3.5 7.57h4.08L5.54 1.96 3.5 7.57Z"
    }, null, -1)
  ])))
}